import { createApiClient } from '@itvisits/api-client';

export const api = createApiClient({ baseUrl: import.meta.env.VITE_API_BASE_URL || '/api/v1' });
export { ApiError } from '@itvisits/api-client';
